import Dexie, { type Table } from 'dexie';
import type { Signature, TrialResult } from './types';

export interface LocalSessionRecord {
  id: string;
  createdAt: string;
  deviceKey: string;
  consentVersion: string;
  synced: number;
}

export interface OutboxRecord {
  id?: number;
  kind: 'trials' | 'summary';
  sessionId: string;
  payload: unknown;
  attempts: number;
  createdAt: string;
  updatedAt: string;
}

export interface LocalSummaryRecord {
  sessionId: string;
  signature: Signature;
  createdAt: string;
  synced: number;
}

class DriftglassDb extends Dexie {
  sessions!: Table<LocalSessionRecord, string>;
  trials!: Table<TrialResult, string>;
  outbox!: Table<OutboxRecord, number>;
  summaries!: Table<LocalSummaryRecord, string>;

  constructor() {
    super('driftglass.v1');
    this.version(1).stores({
      sessions: 'id, createdAt, synced',
      trials: 'id, sessionId, condition, createdAt',
      outbox: '++id, kind, sessionId, updatedAt',
      summaries: 'sessionId, createdAt, synced'
    });
  }
}

export const db = new DriftglassDb();

export async function persistTrial(trial: TrialResult) {
  await db.trials.put(trial);
  await db.outbox.add({
    kind: 'trials',
    sessionId: trial.sessionId,
    payload: { trials: [trial] },
    attempts: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
}

export async function persistSummary(sessionId: string, signature: Signature) {
  await db.summaries.put({ sessionId, signature, createdAt: new Date().toISOString(), synced: 0 });
  await db.outbox.add({
    kind: 'summary',
    sessionId,
    payload: { summary: signature },
    attempts: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
}
